/**
 * An RMA row on the orders list stays blue until it is booked in (or archived, which
 * the row colour logic checks first), rather than only for the first hour.
 */
export function isOpenRma(row: {
  type?: string | null
  return_request_source_rma?: unknown
  bookedIn?: boolean | null
}) {
  const isRma = row.type === "return_request" || !!row.return_request_source_rma
  return isRma && !row.bookedIn
}
